export default __webpack_public_path__ + "static/media/primary.a18f2b7a.png";